function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.237 14.91H6.77a2.707 2.707 0 01-2.708-2.707v-1.354a.677.677 0 00-.676-.677h-.961A2.436 2.436 0 01.002 7.736 7.587 7.587 0 016.919.02a7.445 7.445 0 017.972 7.973 7.573 7.573 0 01-7.655 6.917zm.21-13.536H7.02a6.227 6.227 0 00-5.665 6.3 1.097 1.097 0 001.07 1.145h.96a2.03 2.03 0 012.031 2.03v1.354a1.354 1.354 0 001.354 1.353h.467a6.227 6.227 0 006.3-5.658 6.09 6.09 0 00-6.09-6.524z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.156 11.187a1.015 1.015 0 11-2.03 0 1.015 1.015 0 012.03 0zM12.184 7.126a1.015 1.015 0 11-2.03 0 1.015 1.015 0 012.03 0zM9.477 3.743a1.015 1.015 0 11-2.03 0 1.015 1.015 0 012.03 0zM5.416 5.097a1.015 1.015 0 11-2.03 0 1.015 1.015 0 012.03 0z"
}))));